// Local dictionary lookup for the static build — mirrors the backend /dictionary route.
// Tgdaya is a flat { word: "中文" } map; Toda/Truku are { word: { zh, en, ... } }.
// The Bible reader carries all three dialects: Tgdaya and Truku today, Toda to come.
import tgdaya from './data/dict_tgdaya.json';
import toda from './data/dict_toda.json';
import truku from './data/dict_truku.json';
import trukuBible from './data/dict_truku_bible.json';
import tgdayaBible from './data/dict_tgdaya_bible.json';

const DIALECT = { toda, truku };
// Hand-reviewed-style trilingual overlays for the Bible corpus, one per dialect;
// consulted before the general dictionaries.
const BIBLE_OVERLAY = { truku: trukuBible, tgdaya: tgdayaBible };
// Match the backend: re.sub(r"[^\w\- ]", "", word.lower()).strip()
const norm = (w) => (w || '').toLowerCase().replace(/[^\w\- ]/g, '').trim();

export function lookupGloss(word, dialect) {
  const key = norm(word);
  if (!key) return '';
  const ov = BIBLE_OVERLAY[dialect];
  if (ov && ov[key] && ov[key].zh) return ov[key].zh;
  const dd = DIALECT[dialect];
  if (dd && dd[key] && dd[key].zh) return dd[key].zh;   // dialect-specific (Chinese)
  if (tgdaya[key]) return tgdaya[key];                  // Tgdaya default
  for (const d of Object.values(DIALECT)) {             // any dialect, for cards w/o a match
    if (d[key] && d[key].zh) return d[key].zh;
  }
  return '';
}

// Trilingual lookup for the reader popup: { zh, en }. The Truku Bible ships a
// hand-built trilingual overlay (dict_truku_bible.json) that takes precedence;
// everything else falls back to the Chinese-only dictionaries (en stays '').
export function lookupGlossFull(word, dialect) {
  const key = norm(word);
  if (!key) return { zh: '', en: '' };
  const ov = BIBLE_OVERLAY[dialect];
  if (ov) {
    const b = ov[key];
    if (b && (b.zh || b.en)) return { zh: b.zh || '', en: b.en || '' };
  }
  const dd = DIALECT[dialect];
  if (dd && dd[key] && (dd[key].zh || dd[key].en)) return { zh: dd[key].zh || '', en: dd[key].en || '' };
  if (tgdaya[key]) return { zh: tgdaya[key], en: '' };
  for (const d of Object.values(DIALECT)) {
    if (d[key] && (d[key].zh || d[key].en)) return { zh: d[key].zh || '', en: d[key].en || '' };
  }
  return { zh: '', en: '' };
}
